/**
 * Created by fworld on 2019/6/29.
 */
const device = {
    name: 'system',
    path: '/delivery/system',
    meta: {title: '成员管理'},
    component: () => import('@/pages/redirect'),
    redirect: {name: 'delivery.system.paySet'},
    children: [
        {
            name: 'delivery.system.paySet',
            path: 'paySet',
            meta: {title: '支付设置'},
            component: () => import('@/pages/Delivery/System/PaySet'),
        },

      {
        name: 'delivery.system.wxApply',
        path: 'wxApply',
        meta: {title: '支付设置'},
        component: () => import('@/pages/Delivery/System/PaySet/Wechat/wxApply'),
      },

        {
            name: 'delivery.system.role',
            path: 'role',
            meta: {title: '角色管理'},
            component: () => import('@/pages/Delivery/System/Role'),
        },

    ]
}

export default device
